import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import { useCart } from '../contexts/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);
  };

  // Default image based on category
  const getDefaultImage = () => {
    if (!product.imageUrl) {
      return '/images/placeholder-product.jpg';
    }
    return product.imageUrl;
  };

  return (
    <Link to={`/product/${product.sku}`} data-testid={`product-card-${product.sku}`}>
      <div className="group bg-white border border-alt-bg hover:border-cape-red product-card soft-shadow h-full flex flex-col">
        {/* Image */}
        <div className="relative overflow-hidden bg-alt-bg aspect-square">
          <img
            src={getDefaultImage()}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {product.featured && (
            <span className="absolute top-3 left-3 bg-gold text-deep-berry px-3 py-1 text-xs font-bold uppercase tracking-wider">
              Featured
            </span>
          )}
          <span className="absolute top-3 right-3 category-badge">
            {product.category}
          </span>
        </div>

        {/* Content */}
        <div className="p-6 flex flex-col flex-grow">
          <h3 className="font-display text-xl mb-2 text-deep-berry group-hover:text-cape-red transition-colors">
            {product.name}
          </h3>
          <p className="text-sm text-[#5C5855] mb-4 line-clamp-2 flex-grow">
            {product.description}
          </p>
          
          <div className="flex items-center justify-between mt-auto">
            <span className="price-tag" data-testid={`product-price-${product.sku}`}>
              ${product.retailPrice.toFixed(2)}
            </span>
            <Button
              onClick={handleAddToCart}
              className="btn-primary flex items-center space-x-2"
              data-testid={`add-to-cart-${product.sku}`}
            >
              <ShoppingCart className="w-4 h-4" />
              <span>Add</span>
            </Button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
